import React from 'react';
import { ThemeProvider } from 'styled-components';
import { GhostArticles } from '@minerva-analytics/pantheon';
import { ArticlesContainer } from './Articles.styles';
import { GHOST_API } from '../../constants';

const Articles = () => {

  const colors = {
    title: 'white',
    featuredbg: '#272727',
    author: '#1BE7FF',
    published: 'white',
    readtime: '#2CEFBC',
    featuredblurb: 'white',
    viewmore: 'white'
  };

  const fonts = {
    title: 'Roboto, sans-serif',
    body: 'Roboto, sans-serif',
  };

  const adsense = {
    AdSenseTop: {
      slot: '5718044232',
    },
    AdSenseMiddle: {
      slot: '7961064192',
    },
  };

  const theme = {
   ghostPublished: `font-weight: 400;`,
   ghostReadTime: `text-transform: uppercase; letter-spacing: 2px; font-weight: 500;`,
   ghostLink: `font-weight: 800; border-bottom: solid 2px #2CEFBC;`,
   ghostViewMore: `:before { content: " "; border-bottom: solid 2px #2CEFBC; width: 8.5rem; bottom: 0; position:absolute; }; margin-bottom: 0;`,
  }

  return (
    <ArticlesContainer>
      <title>Quickscope: Video Gaming News</title>
      <meta
        name="og:title"
        property="og:title"
        content="Quickscope: Video Gaming News"
      />
      <meta
        name="og:description"
        property="og:description"
        content="Quickscope is your destination for all video game news."
      />
      <meta
        name="description"
        property="description"
        content="Quickscope is your destination for all video game news."
      />
      <ThemeProvider theme={theme}>
        <GhostArticles 
          ghostApi={GHOST_API} 
          colors={colors} 
          fonts={fonts}
          adsense={adsense}
        />
      </ThemeProvider>
    </ArticlesContainer>
  );
}

export default Articles;